import { RotateCwIcon } from 'lucide-preact'
import { useCallback, useEffect, useState } from 'preact/hooks'
import { compare, parse } from 'semver'

export const AppUpdateNotifier = () => {
	const [newerVersion, setNewerVersion] = useState<string | undefined>()

	const checkVersion = useCallback(() => {
		fetch(`/.well-known/release?v=${VERSION}`)
			.then(async (res) => (await res.text()).trim())
			.then(parse)
			.then((releasedVersion) => {
				if (releasedVersion === null) return
				if (compare(releasedVersion, VERSION) > 0) {
					console.warn(`[App]`, `a newer version is available`, releasedVersion)
					setNewerVersion(releasedVersion.raw)
				} else {
					console.debug(
						`[App]`,
						`release version`,
						releasedVersion.raw,
						`is older`,
					)
				}
			})
			.catch((err) => {
				console.error(`[AppUpdateNotifier]`, err)
			})
	}, [])

	useEffect(() => {
		const i = setInterval(checkVersion, 10 * 60 * 1000)
		checkVersion()
		return () => {
			clearInterval(i)
		}
	}, [checkVersion])

	if (newerVersion === undefined) return null
	return (
		<div role="alert" class="bg-sun" style={{ marginBottom: '1px' }}>
			<div class="container">
				<div class="row">
					<div class="col p-2 d-flex justify-content-between align-items-center">
						<div>
							<RotateCwIcon
								size={36}
								strokeWidth={1}
								class="me-2"
								title={`A newer version ({newerVersion}) is available.`}
							/>
							<span>A newer version ({newerVersion}) is available.</span>
						</div>
						<span class="flex-shrink-0">
							<a href="./" class="btn btn-outline-secondary ms-2">
								reload
							</a>
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}
